// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import router from './router'
import axios from 'axios'
import VueAxios from 'vue-axios'
import App from './App.vue'
import ElementUI from 'element-ui'
// import './../element-variables.scss'
// import 'element-ui/lib/theme-chalk/index.css'
import store from './store/index.js'
import animated from 'animate.css'
import gobal from './assets/css/gobal.scss'
Vue.use(animated)
import './theme/index.css'
Vue.use(ElementUI)
import Setnum from '../common/setNumber.js';
Vue.config.productionTip = false;
Vue.use(VueAxios, axios);
import { MessageBox, Message } from 'element-ui';
import i18n from './plugins/i18n'

axios.interceptors.request.use(config => {
  if (sessionStorage.getItem("Authorization")) {
    const token = JSON.parse(sessionStorage.getItem("Authorization")).token
    token ? config.headers.token = token : null;
  }
  config.headers.source = 'WEB'
  config.headers.language = store.state.lang || 'zh'
  return config
});

// const devURL = 'http://192.168.1.12:8080';
// const devURL = 'https://www.yundaomen.com.cn:8080/' //测试
// const proUrl = 'https://www.yundaomen.com:8080'
// const host = process.env.NODE_ENV === 'development' ? devURL : proUrl
// axios.defaults.baseURL = host


const host = process.env.NODE_ENV === 'development' ? 'https://www.uat.yundaomen.com.cn:8080' : 'https://www.yundaomen.com:8080'
axios.defaults.baseURL = host
// axios.defaults.baseURL = 'https://www.uat.yundaomen.com.cn:8080' // 测试
// axios.defaults.baseURL = 'https://www.yundaomen.com:8080' // 生产
// axios.defaults.baseURL = 'http://192.168.1.130:8080' // hanson那边打包地址
// axios.defaults.baseURL = 'http://192.168.1.150:8080' // mingo
// axios.defaults.baseURL = 'http://192.168.1.23:8080' // 吴谦
// axios.defaults.baseURL = 'http://192.168.2.144:8083' // August
// axios.defaults.baseURL = 'http://192.168.2.94:8083' // Jeffrey

store.commit('setBaseUrl', axios.defaults.baseURL)
Vue.prototype.$Setnum = Setnum
axios.interceptors.response.use(
  response => {
    return response
  },
  error => {
    if (error.response) {
      if (error.response.status == '401') {
        // confirm('登录已过期,请重新登录')
        MessageBox.alert('登录已过期,请重新登录', '提示', {
          confirmButtonText: '确定',
          callback: action => {
            localStorage.clear();
            store.state.Authorization = null
            sessionStorage.removeItem('Authorization')
            router.replace({
              path: '/'
            }).catch(err => err)
            store.commit('changeLogin', true)
          }
        })
        // localStorage.clear();
        // store.state.Authorization = null
        // sessionStorage.removeItem('Authorization')
        // router.replace({
        //   path: '/'
        // })
      }
    }
    return Promise.reject(error.response.data)
  })
// router.beforeEach((to,from,next)=>{
//   console.log(to)
//   if(to.path!=='/index/placeOrder/placeIndex'){

//   }

//   next()
// })




// import moment from 'moment/moment'
// Vue.prototype.$moment = moment
// Vue.filter('moment', function (value, formatString) {
//   formatString = formatString || 'YYYY-MM-DD';
//   return moment(value).format(formatString); // value可以是普通日期 20170723
//   // return moment.unix(value).format(formatString); // 这是时间戳转时间
// });

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js